import { IForm } from '../../../../core/modules/business-process/business-process.types';

export enum BpRegistrationBySmsFormKeys {
  VerifyBySmsForm = 'verify-by-sms-form',
  SmsCodeForm = 'sms-code-form',
}

export interface BpVerifyBySmsForm extends IForm {
  fields: BpVerifyBySmsFields;
  formKey: BpRegistrationBySmsFormKeys.VerifyBySmsForm;
}
export interface BpVerifyBySmsFields {
  IIN: string;
  phone: string;
  smsCodeParamsAttempts: string;
  smsCodeParamsBlocked: string;
  smsCodeParamsResend: string;
  userLang: string;
}
export interface BpVerifyBySmsRequest {
  IIN: string;
  phone: string;
  userLang: string;
}

export interface BpSmsCodeForm extends IForm {
  fields: BpSmsCodeFields;
  formKey: BpRegistrationBySmsFormKeys.SmsCodeForm;
}
export interface BpSmsCodeFields {
  smsCode: string;
  smsCodeParamsAttempts: string;
  smsCodeParamsBlocked: string;
  smsCodeParamsResend: string;
}
